import { render, staticRenderFns } from "./WebSpeechRecognize.vue?vue&type=template&id=7d23d288"
import script from "./WebSpeechRecognize.vue?vue&type=script&lang=js"
export * from "./WebSpeechRecognize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports